export default __webpack_public_path__ + "static/media/BG_Page_05.47bde46f.svg";